const isLocalCheckoutDomain = (value: string): boolean => {
  const normalized = value.trim().toLowerCase();
  return normalized === 'localhost' || normalized.endsWith('.localhost') || normalized.endsWith('.local');
};

const CHECKOUT_PREFIX = 'checkout.';
const AUTH_PREFIX = 'auth.';

const deriveCheckoutHost = (checkoutDomain?: string | null): string | null => {
  const trimmed = checkoutDomain?.trim();
  if (!trimmed) {
    return null;
  }

  const normalized = trimmed.toLowerCase();
  if (normalized.startsWith(CHECKOUT_PREFIX)) {
    return trimmed;
  }

  let baseDomain = trimmed;
  if (normalized.startsWith(AUTH_PREFIX)) {
    baseDomain = trimmed.slice(AUTH_PREFIX.length);
  }

  if (!baseDomain) {
    return null;
  }

  return `${CHECKOUT_PREFIX}${baseDomain}`;
};

export const resolveCheckoutOrigin = (
  checkoutDomain?: string | null,
  checkoutDomainEnabled = true,
): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  if (!checkoutDomainEnabled) {
    return window.location.origin;
  }

  const checkoutHost = deriveCheckoutHost(checkoutDomain);
  if (!checkoutHost) {
    return window.location.origin;
  }

  const protocol = isLocalCheckoutDomain(checkoutHost) ? 'http:' : window.location.protocol;
  return `${protocol}//${checkoutHost}`;
};

export const resolveAuthOriginFromCheckout = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const hostname = window.location.hostname;
  if (!hostname.toLowerCase().startsWith(CHECKOUT_PREFIX)) {
    return null;
  }

  const baseDomain = hostname.slice(CHECKOUT_PREFIX.length);
  if (!baseDomain) {
    return null;
  }

  const authHost = `${AUTH_PREFIX}${baseDomain}`;
  const protocol = isLocalCheckoutDomain(authHost) ? 'http:' : window.location.protocol;
  return `${protocol}//${authHost}`;
};
